import { Injectable } from '@angular/core';
import { RouteRenderModalService } from './route-render-modal.service';
import { AnalyticsService, getCachedTenantData } from '@laasy/common-layout';
import { profileCompletionPage, SegmentConstants, SegmentEvent } from '../utilities/constants';
import { Router } from '@angular/router';
import { isProfileCompSubmitSession, isProfileCompViewedOnceSessionKey } from 'src/app/modules/auth/auth-constants';

@Injectable({
  providedIn: 'root'
})
export class MissingInfoModalService {

  forcedProfileCompletion = false;

  constructor(private routeRenderModalService: RouteRenderModalService, private router: Router, private analyticsService: AnalyticsService) { }

  private _openMissingInfoModal(modalName: string, width?: string) {
    const modalConfig = { ...profileCompletionPage.defaultConfig };
    modalConfig.closable = this.isSkipable;
    if (width) modalConfig.width = width;
    this.router.navigate([{
      outlets: {
        modal: [modalName]
      }
    }], {
      state: { modalConfig: modalConfig }
    });
  }

  private async navigateToProfileCompletion(email: string) {
    this.router.navigate(['']);
    setTimeout(() => {
      this._openMissingInfoModal(profileCompletionPage.modalType.profileCompletion);
      this.analyticsService.segmentTrackEvent( { email: email, action: SegmentConstants.entered}, SegmentEvent.profileCompletionPage);
    }, 500)
  }

  openSurveyCompletionModal() {
    this._openMissingInfoModal(profileCompletionPage.modalType.surveyCompletion, '75vw');
  }

  openProfileCompletion(email: string) {

    if (this.forcedProfileCompletion) {
      this.forcedProfileCompletion = false;
      this.navigateToProfileCompletion(email);
    }
    else{
      const isUserViewedOnce = localStorage.getItem(isProfileCompViewedOnceSessionKey) === 'true';
      const isProfileCompSubmit = localStorage.getItem(isProfileCompSubmitSession.key) === 'true';
      if(this.isSkipable && isUserViewedOnce) return;
      if(!this.isSkipable && isProfileCompSubmit) return;
      this.navigateToProfileCompletion(email);
    }

    localStorage.setItem(isProfileCompViewedOnceSessionKey, 'true');
  }

  async closeModal() {
    this.routeRenderModalService.closeModal();
  }

  get isSkipable(): boolean {
    const tenantData = getCachedTenantData();
    return tenantData?.isSurveyResponseSkipabble;
  }
}
